import {generateAsyncActionCreators} from '../core/reduxUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';

const getBrandInfoActionCreators = generateAsyncActionCreators(
  'GET_BRAND_INFO',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getBrandProductsActionCreators = generateAsyncActionCreators(
  'GET_BRAND_PRODUCTS',
  (params,cookies) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
  })
);

const getNextBrandProductsActionCreators = generateAsyncActionCreators(
  'GET_NEXT_BRAND_PRODUCTS',
  (params,cookies) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
  })
);

const getBrandByIdActionCreators = generateAsyncActionCreators(
  'GET_BRAND_BY_ID',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getBrandByProductBrandNameActionCreators = generateAsyncActionCreators(
  'GET_BRAND_BY_NAME',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getSimilarBrandsActionCreators = generateAsyncActionCreators(
  'GET_SIMILAR_BRANDS',
  (params) => ({
    params
  })
);

const actionCreators = {
  getBrandInfo: {
    ...getBrandInfoActionCreators,
  },
  getBrandProducts: {
    ...getBrandProductsActionCreators,
  },
  getNextBrandProducts: {
    ...getNextBrandProductsActionCreators,
  },
  getBrandById: {
    ...getBrandByIdActionCreators,
  },
  getBrandByProductBrandName: {
    ...getBrandByProductBrandNameActionCreators,
  },
  getSimilarBrands:{
    ...getSimilarBrandsActionCreators,
  }
};

export {
  actionCreators,
  getBrandInfoActionCreators,
  getBrandProductsActionCreators,
  getNextBrandProductsActionCreators,
  getBrandByIdActionCreators,
  getBrandByProductBrandNameActionCreators,
  getSimilarBrandsActionCreators,
};
